import ActivityList from "./components/activity/ActivityList";

export const ActivityPage = () => {

  return (
    <>
      <div>
        <ActivityList />
      </div>
    </>
  );
};
